import { UIHeading5, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants/symbols';

import * as styles from './BookedOfferDisclaimer.css';

export function BookedOfferDisclaimer() {
  return (
    <div className={styles['container']} data-testid="booked-offer-disclaimer">
      <div className={styles['lock']}></div>
      <div className={styles['text']}>
        <UIHeading5 fontWeight="bold">Забронирована</UIHeading5>
        <UIText3>
          Застройщик подберёт похожую или запишет вас{NBSP}в{NBSP}очередь
        </UIText3>
      </div>
    </div>
  );
}
